import {
  CONSTRUCTIONS_AUTOCOMPLETE_LOADING,
  CONSTRUCTIONS_AUTOCOMPLETE_UPDATE
} from "../actions/constructionsAutocompleteActions";

const INITIAL_STATE = {
  constructions: [],
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONSTRUCTIONS_AUTOCOMPLETE_UPDATE:
      return {
        ...state,
        constructions: action.payload.data,
      };
    case CONSTRUCTIONS_AUTOCOMPLETE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/works/reducers/ConstructionsAutocompleteReducer.js